package com.cybersoftsolution.cybersoftsolutionweb.components.htmlEditor

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButton
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButtonType
import com.cybersoftsolution.cybersoftsolutionweb.components.htmlEditor.EditorKey.*
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.editorIdPreview
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.previewButtonId
import com.varabyte.kobweb.compose.css.GridEntry
import com.varabyte.kobweb.compose.css.GridTrackBuilder
import com.varabyte.kobweb.compose.css.GridTrackBuilderInRepeat
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.style.KobwebComposeStyleSheet.add
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gridTemplateColumns
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import kotlinx.browser.document
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.px


@Composable
    fun EditorControls(
        editorId: String,
        modifier: Modifier = Modifier,
        onPreviewClick: () -> Unit = {},
        editorVisibility: Boolean
    ){
        SimpleGrid(
            modifier = modifier,
            numColumns = numColumns(base = 1, md = 2 )
        ){
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Start,
                modifier = Modifier//.fillMaxWidth()

                    .overflow(Overflow.Auto)
                    .scrollBehavior(ScrollBehavior.Smooth)
                    .position(Position.Static)
                    .padding(8.px)

            ) {

                Row {
                    EditorKey.entries.forEach { keyIcon ->
                        Box(
                            modifier = Modifier
                                .margin(leftRight = 3.px)
                                .height(38.px)
                                .width(38.px)
                        ) {
                            EditorKeyIcon(
                                enabled = if (editorVisibility) true else false,
//                            modifier = Modifier,
                                editorKey = keyIcon,
                                onClick = {
                                    when(keyIcon){
                                        BoldIcon -> {
                                            verifyControlStyle(editorId = editorId, controlStyle = ControlStyle.Bold(selectedText = getEditor(id = editorId).getSelectedText()))
                                        }
                                        HeadingIcon -> {
                                            verifyControlStyle(editorId = editorId, controlStyle = ControlStyle.Heading(selectedText = getEditor(id = editorId).getSelectedText()))
                                        }
                                        ItalicIcon -> {
                                            verifyControlStyle(editorId = editorId, controlStyle = ControlStyle.Italic(selectedText = getEditor(id = editorId).getSelectedText()))
                                        }
                                        UnderlineIcon -> {
                                            verifyControlStyle(editorId = editorId, controlStyle = ControlStyle.Underline(selectedText = getEditor(id = editorId).getSelectedText()))
                                        }
                                        LinkIcon -> {
                                            verifyControlStyle(editorId = editorId, controlStyle = ControlStyle.Link(selectedText = getEditor(id = editorId).getSelectedText(), url = "Set_URL", title = "Set_Title"))
                                        }
                                        ImageIcon -> {
                                            verifyControlStyle(editorId = editorId, controlStyle = ControlStyle.Image(selectedText = getEditor(id = editorId).getSelectedText(), title = "Set_Title"))
                                        }
                                        Title -> {
                                            verifyControlStyle(editorId = editorId, controlStyle = ControlStyle.Title(selectedText = getEditor(id = editorId).getSelectedText()))
                                        }
                                        CodeIcon -> {
                                            verifyControlStyle(editorId = editorId, controlStyle = ControlStyle.Code(selectedText = getEditor(id = editorId).getSelectedText()))
                                        }
                                        YoutubeIcon -> {
                                            verifyControlStyle(editorId = editorId, controlStyle = ControlStyle.Youtube(selectedText = getEditor(id = editorId).getSelectedText(), title = "Set_Title"))
                                        }
                                        TikTokIcon -> {
                                            verifyControlStyle(editorId = editorId, controlStyle = ControlStyle.TikTok(selectedText = getEditor(id = editorId).getSelectedText(), title = "Set_Title"))
                                        }
                                        Subtitle -> {
                                            verifyControlStyle(editorId = editorId, controlStyle = ControlStyle.Subtitle(selectedText = getEditor(id = editorId).getSelectedText()))
                                        }
                                        Quote -> {
                                            verifyControlStyle(editorId = editorId, controlStyle = ControlStyle.Quote(selectedText = getEditor(id = editorId).getSelectedText()))
                                        }
                                        Paragraph -> {
                                            verifyControlStyle(editorId = editorId, controlStyle = ControlStyle.Paragraph(selectedText = getEditor(id = editorId).getSelectedText()))
                                        }


                                    }
                                }
                            )
                        }

                    }

                }
            }




            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = if (isDesktop()) Arrangement.End else Arrangement.Center,
                modifier = Modifier.fillMaxWidth()
                    .padding(8.px)
            ) {

                MyButton(
                    buttonType = if (editorVisibility) MyButtonType.Secondary else MyButtonType.Primary,
                    modifier = Modifier.padding(leftRight = 8.px).borderRadius(25.px),
                    id = previewButtonId,
                    text = if (editorVisibility) "Previsualizar" else "Listo",
                    onClick = {
                        document.getElementById(editorId+ editorIdPreview)?.innerHTML = getEditor(id = editorId).value
                        onPreviewClick()
                        js(code = "hljs.highlightAll();")  as Unit
                    }
                )

            }

        }

    }